import { IPayFee, IPayMethod, IPayMethodGate } from './interfaces/reduces.refill.interfaces';
import f5 from './assets/5.png';
import f10 from './assets/10.svg';
import f15 from './assets/15.svg';
import f25 from './assets/25.png';
import f30 from './assets/30.svg';
import f50 from './assets/50.svg';
import f100 from './assets/100.svg';
import f200 from './assets/200.svg';
import f300 from './assets/300.svg';
import f500 from './assets/500.svg';
import f700 from './assets/700.svg';
import f1000 from './assets/1000.png';
import { URLS } from 'services/constant-urls';
import { ReferralCampaignTypes } from 'core/User/interfaces';

export const chipDictionary = [
  {
    img: f10,
    price: 1000,
  },
  {
    img: f15,
    price: 1500,
  },
  {
    img: f30,
    price: 3000,
  },
  {
    img: f50,
    price: 5000,
  },
  {
    img: f100,
    price: 10000,
  },
  {
    img: f200,
    price: 20000,
  },
  {
    img: f300,
    price: 30000,
  },
  {
    img: f500,
    price: 50000,
  },
  {
    img: f700,
    price: 70000,
  },
];

export const prepaidChips = [
  {
    img: f5,
    price: 500,
    url: `${URLS.giftCard}/82757/csgofast-5-usd-gift-card?referrer=csgofast.com`,
  },
  {
    img: f10,
    price: 1000,
    url: `${URLS.giftCard}/82747/csgofast-10-usd-gift-card?referrer=csgofast.com`,
  },
  {
    img: f25,
    price: 2500,
    url: `${URLS.giftCard}/82758/csgofast-25-usd-gift-card?referrer=csgofast.com`,
  },
  {
    img: f50,
    price: 5000,
    url: `${URLS.giftCard}/82759/csgofast-50-usd-gift-card?referrer=csgofast.com`,
  },
  {
    img: f100,
    price: 10000,
    url: `${URLS.giftCard}/82760/csgofast-100-usd-gift-card?referrer=csgofast.com`,
  },
  {
    img: f200,
    price: 20000,
    url: `${URLS.giftCard}/82761/csgofast-200-usd-gift-card?referrer=csgofast.com`,
  },
  {
    img: f500,
    price: 50000,
    url: `${URLS.giftCard}/124316/csgofast-500-usd-gift-card?referrer=csgofast.com`,
  },
  {
    img: f1000,
    price: 100000,
    url: `${URLS.giftCard}/124317/csgofast-1000-usd-gift-card?referrer=csgofast.com`,
  },
];

export const G2G_GIFT_CARDS = [
  {
    url: `${URLS.g2GiftCard}-10-usd-csgofast-key-global-i10000280070006?aid=13099141`,
    img: f5,
    price: 500,
  },
  {
    url: `${URLS.g2GiftCard}-10-usd-csgofast-key-global-i10000280070005?aid=13099146`,
    img: f10,
    price: 1000,
  },
  {
    url: `${URLS.g2GiftCard}-25-usd-csgofast-key-global-i10000280070003?aid=13099147`,
    img: f25,
    price: 2500,
  },
  {
    url: `${URLS.g2GiftCard}-50-usd-csgofast-key-global-i10000280070004?aid=13099148`,
    img: f50,
    price: 5000,
  },
  {
    url: `${URLS.g2GiftCard}-100-usd-csgofast-key-global-i10000280070002?aid=13099151`,
    img: f100,
    price: 10000,
  },
  {
    url: `${URLS.g2GiftCard}-200-usd-csgofast-key-global-i10000280070001?aid=1309915`,
    img: f200,
    price: 20000,
  },
  {
    url: `${URLS.g2GiftCard}-500-fast-coins-csgofast-key-global-i10000280070008`,
    img: f500,
    price: 50000,
  },
  {
    url: `${URLS.g2GiftCard}-1000-fast-coins-csgofast-key-global-i10000280070007`,
    img: f1000,
    price: 100000,
  },
];

export const depositBonus: Record<number, number> = {
  500: 1,
  1000: 2,
  2500: 3,
  5000: 4,
  10000: 5,
  20000: 5,
  50000: 6,
  100000: 7,
};

export const countriesDictionary: { [key: string]: string } = {
  AF: 'Afghanistan',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia, Plurinational State of',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  CV: 'Cape Verde',
  BQ: 'Caribbean Netherlands',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Congo',
  CD: 'Congo, the Democratic Republic of the',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  CI: 'Côte d`Ivoire',
  HR: 'Croatia',
  CU: 'Cuba',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  'GB-ENG': 'England',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  EU: 'Europe',
  FK: 'Falkland Islands (Malvinas)',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island and McDonald Islands',
  VA: 'Holy See (Vatican City State)',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran, Islamic Republic of',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KP: 'Korea, Democratic People`s Republic of',
  KR: 'Korea, Republic of',
  XK: 'Kosovo',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: 'Lao People`s Democratic Republic',
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'Macedonia, the former Yugoslav Republic of',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia, Federated States of',
  MD: 'Moldova, Republic of',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  AN: 'Netherlands Antilles',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  'GB-NIR': 'Northern Ireland',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestine',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RE: 'Réunion',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  BL: 'Saint Barthélemy',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin',
  PM: 'Saint Pierre and Miquelon',
  VC: 'Saint Vincent and the Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  'GB-SCT': 'Scotland',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SX: 'Sint Maarten (Dutch part)',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia and the South Sandwich Islands',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard and Jan Mayen Islands',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania, United Republic of',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks and Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  US: 'United States',
  UY: 'Uruguay',
  UM: 'US Minor Outlying Islands',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela, Bolivarian Republic of',
  VN: 'Viet Nam',
  VG: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  'GB-WLS': 'Wales',
  WF: 'Wallis and Futuna Islands',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  AX: '\u00c5land Islands',
};

export const refillAdapter = (methods: IPayMethod[], payFee: IPayFee): IPayMethod[] => {
  return methods.map((method: IPayMethod) => ({
    ...method,
    is_disabled: method.gates.every(value => !value.is_enabled),
    commission: method.gates.find(({ comission }: IPayMethodGate) => !!comission)?.comission || '',
    bonus: method.gates
      .filter(gate => gate.is_enabled)
      .map(gate =>
        !isNaN(payFee[`${gate.title}_${method.name}`])
          ? payFee[`${gate.title}_${method.name}`] - 100
          : 0
      ),
  }));
};

export const getAmountWithBonus = (
  amount: number,
  reward: number,
  type: ReferralCampaignTypes,
  rewarded: boolean
) => {
  if (!rewarded) {
    if (type === ReferralCampaignTypes.MONEY_NEW || type === ReferralCampaignTypes.MONEY_OLD) {
      return amount >= 1540 ? amount + reward : amount;
    }
    return amount >= 1540 ? amount + (amount * reward) / 100 : amount;
  } else {
    return amount;
  }
};
